import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-orderplanning',
  templateUrl: './orderplanning.component.html',
  styleUrls: ['./orderplanning.component.scss']
})
export class OrderplanningComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
